// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"0dd04a76","145":"216a6a69"}[chunkId] + ".chunk.css";
};